import { getLogoForCoin } from '@src/service/coins/coins'
import { SelectWrapper } from './CurrencySelect.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

interface CurrencySelectProps {
  currency: string
  openListView: () => void
}

export const CurrencySelect = ({ currency, openListView }: CurrencySelectProps) => {
  return (
    <SelectWrapper>
      <div className="select" onClick={openListView}>
        <div className="currency">
          <img className="coin-image" alt={currency} src={getLogoForCoin(currency)} />
          {currency}
        </div>
        <FontAwesomeIcon icon={faChevronDown} />
      </div>
    </SelectWrapper>
  )
}
